__turbopack_context__.v({
  "alignCenter": "PanelContentHeader-module__jXmEAW__alignCenter",
  "alignLeft": "PanelContentHeader-module__jXmEAW__alignLeft",
  "tableCell": "PanelContentHeader-module__jXmEAW__tableCell",
});
